import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { dataSourceHistoryActionTypes, dataSourceHistoryLoadingAction, dataSourceHistoryLoadedAction, } from '../ducks/DataSourceDetailHistory.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
const loadDataSourceHistoryArgs = {
    filterOnType: dataSourceHistoryActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSourceHistory(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceHistoryLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceHistoryLoadedAction(payload, result));
    },
};
export const loadDataSourceHistoryEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceHistoryArgs);
export default combineEpics(loadDataSourceHistoryEpic);

//# sourceMappingURL=DataSourceHistoryEpic.js.map
